import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["foodAmount", "deliveryFee", "taxAmount", "otherAmount", "totalAmount"]

  connect() {
    // 기존 값들에 콤마 포맷팅 적용
    this.formatExistingValues()
    this.calculate()
  }

  formatExistingValues() {
    const targets = [this.foodAmountTarget, this.deliveryFeeTarget, this.otherAmountTarget]
    targets.forEach(target => {
      const value = this.parseAmount(target.value)
      if (value > 0) {
        target.value = this.formatNumber(value)
      }
    })
  }

  calculate() {
    const food = this.parseAmount(this.foodAmountTarget.value)
    const delivery = this.parseAmount(this.deliveryFeeTarget.value)
    const other = this.parseAmount(this.otherAmountTarget.value)

    // 부가세 자동 계산: (음식값 + 배송비 + 기타) × 10%
    const tax = Math.round((food + delivery + other) * 0.1)

    // 부가세 필드 업데이트
    this.taxAmountTarget.value = tax > 0 ? this.formatNumber(tax) : ""

    const total = food + delivery + other + tax
    this.totalAmountTarget.value = total > 0 ? this.formatNumber(total) : ""
  }

  // 입력 시 콤마 포맷팅
  formatInput(event) {
    const input = event.target
    const cursorPos = input.selectionStart
    const oldValue = input.value
    const oldLength = oldValue.length

    const value = this.parseAmount(input.value)
    input.value = value > 0 ? this.formatNumber(value) : ""

    // 커서 위치 조정
    const newLength = input.value.length
    const diff = newLength - oldLength
    const newCursorPos = Math.max(0, cursorPos + diff)
    input.setSelectionRange(newCursorPos, newCursorPos)

    this.calculate()
  }

  parseAmount(value) {
    const cleaned = String(value).replace(/,/g, "")
    // parseFloat 후 Math.round로 소수점 처리
    const parsed = parseFloat(cleaned)
    return isNaN(parsed) ? 0 : Math.round(parsed)
  }

  formatNumber(num) {
    // 항상 정수로 표시 (소수점 없음)
    return Math.round(num).toLocaleString('ko-KR')
  }
}
